import { Platform } from 'react-native';

/**
 * Downloads a base64-encoded file on web by creating a blob and triggering
 * a browser download. On native platforms, this is a no-op (use RNFS + FileViewer instead).
 */
export const downloadFileWeb = (
  base64Data: string,
  fileName: string,
  mimeType: string = 'application/pdf',
) => {
  if (Platform.OS !== 'web') return;

  // Strip data URI prefix if present
  const cleanBase64 = base64Data.includes(',')
    ? base64Data.split(',')[1]
    : base64Data;

  // Convert base64 to binary
  const byteCharacters = atob(cleanBase64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: mimeType });

  // Create download link and trigger click
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Clean up the object URL after a short delay
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
